<template>
    <div>
        <div class="app-body">
            <page-header></page-header>
            <div class="allContain">
                <nav-bar/>
                <div class="accountSet">
                    <h3 class="title">我的问卷</h3>
                    <search-bar @onSearch="onSearch" class="search-form"/>
                    <question-card :question-list="questionList"
                                   @onCardClick="handleCardClick"
                                   wrapper-class="questionnaire-list"/>
                    <pagination :p-size.sync="pageSize"
                                :page-sizes="[12, 24, 36, 48]"
                                :page-no.sync="pageIndex"
                                @change="getQuestionnaireList"
                                :total="total"/>
                </div>
            </div>
        </div>
        <bottom-ground></bottom-ground>
    </div>
</template>

<script>
import BottomGround from "@/components/bottomnav";
import PageHeader from "@/components/header";
import NavBar from "@/components/personCenter/nav";
import { getQuestionnaireList } from "@/api/new-question-iteration/question-user"
import { QUESTION_STATUS_USER } from "@/utils/question-config"
import { parseDate } from "element-ui/src/utils/date-util";
import questionCard from "@/components/questionCard";
import pagination from "@/components/Pagination";
import SearchBar from "@/views/psq/cpns/searchBar.vue"
export default {
    components: {
        BottomGround,
        PageHeader,
        NavBar,
        questionCard,
        pagination,
        SearchBar
    },
    created() {
        this.getQuestionnaireList()
    },
    data() {
        return {
            pageIndex: 1,
            pageSize: 12,
            total: 12,
            questionList: [],
            QUESTION_STATUS_USER
        };
    },
    methods: {
        // 获取问卷列表
        getQuestionnaireList() {
            const { pageSize, pageIndex, searchForm = {} } = this
            getQuestionnaireList({
                pageSize,
                pageIndex,
                Type: 1,
                ...searchForm
            }).then(res => {
                this.questionList = res.data
                this.total = res.count
            })
        },
        // 处理card点击
        handleCardClick(item) {
            switch (true) {
            case item.State === 0: {
                this.$message.warning("问卷还未开始，请在规定时间内作答")
                break;
            }
            case item.State === 1: {
                this.$router.push({
                    name: "DoQuestionnaire",
                    query: { Qid: item.Id, isViewResult: item.IsUserDispalyResult, from: this.$route.path }
                })
                break;
            }
            case item.State === 2: {
                const endTimeStamp = parseDate(item.QuestionnaireEndTime, "yyyy-MM-dd HH:mm:ss").getTime()
                if (new Date().getTime() >= endTimeStamp) {
                    this.$message.warning("问卷已结束")
                } else {
                    this.$confirm("问卷已作答，继续作答将覆盖之前的作答记录，是否继续", "温馨提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(res => {
                        this.$router.push({
                            name: "DoQuestionnaire",
                            query: { Qid: item.Id, isViewResult: item.IsUserDispalyResult, from: this.$route.path }
                        })
                    })
                }
                break;
            }
            case item.State === 3: {
                this.$message.warning("问卷已结束")
                break;
            }
            }
        },
        onSearch (form) {
            this.searchForm = form
            this.pageIndex = 1
            this.getQuestionnaireList()
        },
    },
};
</script>

<style lang="less" scoped>
::v-deep .questionnaire-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    padding: 0 30px 30px;
    // 间隙
    grid-gap: 30px;
}
.allContain {
    width: 100%;
    margin: 20px auto 30px;
    display: flex;
    justify-content: space-between;

    .accountSet {
        width: 940px;
        min-height: 830px;
        background-color: #fff;
        border-radius: 16px;
    }
}

.title {
    margin: 0;
    padding: 0 30px;
    height: 80px;
    line-height: 80px;
    font-size: 16px;
}
.search-form {
    padding: 0 30px;
    box-sizing: border-box;
}
</style>
